import {useGrpcRequestMutation} from '@aboutyou/data-fetcher';
import {NewsletterSubscriptionService_UnsubscribeFromNewsletterWithTokenLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/newsletter_subscription/v1/service.grpc.lazy';

export function useUnsubscribeFromNewsletterWithToken(
  onSuccess: () => void,
  onError: () => void,
) {
  const unsubscribeFromNewsletterWithToken = useGrpcRequestMutation(
    NewsletterSubscriptionService_UnsubscribeFromNewsletterWithTokenLazy,
    {
      onSuccess: () => {
        onSuccess();
      },
      onError: () => {
        onError();
      },
    },
  );

  return (token: string, permission: string) => {
    return unsubscribeFromNewsletterWithToken.mutateAsync({
      token,
      permission,
    });
  };
}
